import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

// Register GSAP plugins once. Guarded so it is a no-op during SSR.
if (typeof window !== 'undefined' && !gsap.core.globals().ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger)
}

export { gsap, ScrollTrigger }
